<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline" v-if="detect == 'pc'">
                <h2 class="tit">보증금 내역</h2>
            </div>

            <v-divider class="d-md-none" />

            <mypage-deposit-list-head class="mb-2 mb-md-12" :class="{ 'mt-n7': detect == 'mobile' }" />

            <v-card elevation="0" style="overflow:visible">
                <v-card-text :class="{ 'pa-0': detect == 'pc' }">
                    <div class="mb-4">
                        <mypage-deposit-list-filter />
                    </div>

                    <mypage-deposit-list-type class="mb-2 mb-md-12" />

                    <div>
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                                itemsPerPage: -1,
                            }"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                            class="mypage-deposit-list__table"
                        >
                            <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
                        </v-data-table>
                    </div>

                    <div class="mt-30px mt-md-40px">
                        <v-pagination
                            v-bind="{
                                value: page,
                                length: pageCount,
                                'total-visible': 11,
                            }"
                            @input="(page) => $router.push({ query: { ...$route.query, page } })"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { initDataTableHeaders } from "@/assets/lib";

import CommonLoader from "@/components/common/common-loader.vue";

import MypageDepositListHead from "@/components/client/mypage/deposit/mypage-deposit-list-head.vue";
import MypageDepositListFilter from "@/components/client/mypage/deposit/mypage-deposit-list-filter.vue";
import MypageDepositListType from "@/components/client/mypage/deposit/mypage-deposit-list-type.vue";

const headers = initDataTableHeaders([
    {
        text: "일시",
        value: "createdAt",
        align: "start",
        width: 180,
        formatterType: "datetime",
    },
    {
        text: "상세내역",
        value: "remark",
        align: "center",
    },
    {
        text: "금액",
        value: "amount",
        align: "end",
        width: 140,
        formatterType: "number",
        formatterSuffix: "원",
    },
    {
        text: "잔액",
        value: "remain",
        align: "end",
        width: 140,
        formatterType: "number",
        formatterSuffix: "원",
    },
]);

export default {
    components: {
        CommonLoader,

        MypageDepositListHead,
        MypageDepositListFilter,
        MypageDepositListType,
    },
    data: () => ({
        deposits: [],
        summary: { totalCount: 0 },

        limit: 10,
        detect,
        headers,

        loading: false,
    }),
    computed: {
        template() {
            switch (detect) {
                case "pc": {
                    return () => import(`@/templates/${this.$theme.pages.mypage}`);
                }

                case "mobile": {
                    return () => import(`@/templates/${this.$theme.pages.default}`);
                }
            }
        },

        items() {
            return [...this.deposits];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, deposits } = await api.v1.me.deposits.gets({
                    headers: { skip, limit },
                    params,
                });

                this.deposits = deposits;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.mypage-deposit-list {
    &__table {
        & ::v-deep .line-height-1-5 {
            line-height: 1.5 !important;
        }
    }
}
</style>
